import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/penny-arcade': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M421.9 164.3C417.4 183.7 420.5 170.3 406.8 229.6L446.5 218.9C424.2 169.3 429.3 180.5 421.9 164.3zM215.8 215.4C195.6 220.8 204.5 218.4 176.2 226L180.7 272.1C208.8 264.6 201.3 266.6 215.5 262.8 257.8 253 248.3 206.4 215.8 215.4zM542 189.2L496.5 90C490.8 77.6 477.1 71.1 463.9 74.7 393.6 93.4 425.2 85 328.3 110.9A27.6-27.6 0 0 1 309.4 128.3C144.3 113.3 0 153.8 0 226.7 0 260.2 30.7 293.8 80.9 322L82.6 339.9A27.9-27.9 0 0 1 64.9 368.6L69.2 413.1C70.6 427.4 82.6 438.3 97 438.3 102.2 438.3 94 440.1 219.5 406.5 232.1 403.1 240.6 391.5 240.1 378.5 456.7 424 642.1 372.5 640 293.7 640 265.5 617.8 227.1 542 189.2zM255.1 298.3L233.2 304.2 184.8 317.1 187.3 340.6 207.8 335.1 212.3 379.6 97 410.4 92.7 365.9 112.7 360.6 101.6 245.9 81.5 251.3 77.1 206.8C255.3 159.3 247.3 160.4 263.3 160.2 320 159 327.5 232 305.9 264.6A86.7-86.7 0 0 0 255.1 298.3zM454.3 314.9L450.4 275.4 465.3 271.4 458.7 256.8 401 272.2 396.9 289.7 416.1 284.6 420.1 324.1 307.3 354.2 302.8 309.8 323.8 304.2 356.9 177.7 339.7 182.3 335.5 137.8C428.9 112.8 400.5 120.4 471.1 101.6L537.8 247 558.6 241.5 562.9 286 454.3 314.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/penny-arcade.js
// module id = O0ls
// module chunks = 144